import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Select,
  Tag,
  Divider,
  Image,
  Spin,
  Row,
  Col,
  PageHeader,
  Modal,
  Form,
  message,
  DatePicker,
  Drawer,
} from "antd";
import {
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import Highlighter from "react-highlight-words";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { connect } from "react-redux";
import { ImageView } from "../../image/imageView";
import { LanguageContext } from "../../../context/LanguageContext";
import { notificationAction } from "../../../_actions/notifications.actions";
import { CountPreventiveNotificationList } from "./countPreventiveNotificationList";
import { professionalAction } from "../../../_actions";
import { PreventiveForm } from "../../ProfessionalForm/Forms/PreventiveForm";
import { PreventiveInfomationTable } from "../../ProfessionalForm/FormsTable/PreventiveInfomationTable";
const { Option } = Select;

const COUNT_MODAL_PIE_COLORS = [
  "#1890ff",
  "#fa8c16",
  "#52c41a",
  "#722ed1",
  "#13c2c2",
  "#eb2f96",
  "#bfbfbf",
];

class TablePreventiveNotificationMemo extends React.Component {
  static contextType = LanguageContext;
  state = {
    imageOpen: false,
    selectedImage: null,
    showList: false,
    finalList: [],
    countModalTitle: "",
    countModalTab: "list",
    countModalGraphType: "district",
    reason: "",
    read_by: false,
    read_data: [],
    date: "",
    preventiveDrawer: false,
    resetPreventiveForm: true,
    preventiveInformationData: [],
    editPreventiveInformationData: [],
    preventiveAction: {},
    accusedPreventiveDrawer: false,
    addPrevetivePopUp: false,
    isSelectOpen: false, // New state to control Select dropdown visibility
  };

  preventiveInfoRef = React.createRef();
  componentDidMount() {
    this.getPreventiveInfo();
  }
  getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          this.setState({
            preventiveAction: {
              data: data,
            },
          });
        });
    });
  };
  openImageModal = (img, name) => {
    this.setState({ imageOpen: true, selectedImage: img, name: name });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };
  openAddPrevetivePopUp = () => {
    console.log("openAddPrevetivePopUp called, setting addPrevetivePopUp to true");
    this.setState({ addPrevetivePopUp: true });
  };
  closeAddPrevetivePopUp = () => {
    console.log("closeAddPrevetivePopUp called, clearing state. Current read_data:", this.state.read_data);
    this.setState({
      addPrevetivePopUp: false,
      read_data: [],
      read_by: false,
      reason:"",
      date:""
    });
    console.log("State after closeAddPrevetivePopUp:", this.state.addPrevetivePopUp, this.state.read_data, this.state.read_by);
  };
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleViewForm = (data) => {
    console.log("data", data);
    this.props.onViewAccusedForm(data);
  };
  getSerialNumber = (index, currentPage, pageSize) => {
    console.log("index, currentPage, pageSize", index, currentPage, pageSize);
    return (currentPage - 1) * pageSize + index;
  };

  buildCountModalPieData = (list, graphType) => {
    if (!list || !list.length) return [];

    const groupKey =
      graphType === "district"
        ? "action_taken_police_station"
        : "preventive_action_name";

    const grouped = list.reduce((acc, item) => {
      const name = item[groupKey] || "-";
      acc[name] = (acc[name] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(grouped)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value);
  };

  renderCountModalPieLegend = (data) => {
    const total = data.reduce((sum, item) => sum + item.value, 0);

    return (
      <div
        style={{
          flex: "0 0 42%",
          minWidth: 180,
          padding: "12px 16px",
          background: "#fafafa",
          borderRadius: 8,
          border: "1px solid #f0f0f0",
        }}
      >
        {data.map((item, idx) => (
          <div
            key={item.name}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
              fontSize: 13,
              color: "#595959",
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background:
                    COUNT_MODAL_PIE_COLORS[idx % COUNT_MODAL_PIE_COLORS.length],
                  flexShrink: 0,
                }}
              />
              {item.name}
            </span>
            <strong style={{ color: "#262626" }}>{item.value}</strong>
          </div>
        ))}
        <div
          style={{
            marginTop: 10,
            padding: "8px 12px",
            background: "#fff",
            borderRadius: 6,
            border: "1px solid #e8e8e8",
            fontWeight: 600,
            fontSize: 13,
            textAlign: "center",
          }}
        >
          एकूण: {total.toLocaleString("en-IN")}
        </div>
      </div>
    );
  };

  renderCountModalToggle = () => {
    const { countModalTab, finalList, loading } = this.state;
    const { t } = this.context;
    const hasExportData = Array.isArray(finalList) && finalList.length > 0;

    return (
      <div
        style={{
          marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 12,
          paddingRight: 8,
        }}
      >
        <div
          style={{
            display: "inline-flex",
            borderRadius: 30,
            border: "3px solid #7c3aed",
            padding: 3,
            background: "#fff",
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          <div
            role="button"
            tabIndex={0}
            onClick={() => this.setState({ countModalTab: "list" })}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.setState({ countModalTab: "list" });
              }
            }}
            style={{
              padding: "8px 24px",
              borderRadius: 26,
              fontWeight: 600,
              fontSize: 14,
              background: countModalTab === "list" ? "#7c3aed" : "#fff",
              color: countModalTab === "list" ? "#fff" : "#7c3aed",
              transition: "all 0.3s ease",
            }}
          >
            यादी (List)
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => this.setState({ countModalTab: "analysis" })}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.setState({ countModalTab: "analysis" });
              }
            }}
            style={{
              padding: "8px 24px",
              borderRadius: 26,
              fontWeight: 600,
              fontSize: 14,
              background: countModalTab === "analysis" ? "#7c3aed" : "#fff",
              color: countModalTab === "analysis" ? "#fff" : "#7c3aed",
              transition: "all 0.3s ease",
            }}
          >
            विश्लेषण (Analysis)
          </div>
        </div>
        {countModalTab === "list" && (
          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            onClick={this.downloadCountModalExcel}
            disabled={!hasExportData || loading}
          >
            {t("download")} {t("excel")}
          </Button>
        )}
      </div>
    );
  };

  renderCountModalGraph = () => {
    const { finalList, loading, countModalGraphType } = this.state;
    const { t } = this.context;
    const pieData = this.buildCountModalPieData(finalList, countModalGraphType);
    const chartTitle =
      countModalGraphType === "district"
        ? t("police_station")
        : t("preventive_action");

    if (loading) {
      return (
        <div style={{ textAlign: "center", padding: 48 }}>
          <Spin />
        </div>
      );
    }

    if (!pieData.length) {
      return (
        <div
          style={{
            height: 280,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#8c8c8c",
            fontSize: 14,
          }}
        >
          डेटा उपलब्ध नाही
        </div>
      );
    }

    return (
      <div>
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#262626",
            marginBottom: 12,
          }}
        >
          {chartTitle}
        </div>
        <div
          style={{
            display: "flex",
            gap: 16,
            alignItems: "center",
            flexWrap: "wrap",
            minHeight: 300,
          }}
        >
          <div style={{ width: "100%", maxWidth: 360, height: 300 }}>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={105}
                  paddingAngle={2}
                >
                  {pieData.map((entry, idx) => (
                    <Cell
                      key={`${entry.name}-${idx}`}
                      fill={
                        COUNT_MODAL_PIE_COLORS[
                          idx % COUNT_MODAL_PIE_COLORS.length
                        ]
                      }
                      stroke="#fff"
                      strokeWidth={2}
                    />
                  ))}
                </Pie>
                <RechartsTooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          {this.renderCountModalPieLegend(pieData)}
        </div>
      </div>
    );
  };

  handleColumnClick = (record) => {
    this.setState({
      showList: true,
      loading: true,
      countModalTab: "list",
      countModalGraphType: "district",
      countModalTitle: record.name || "आरोपी",
    });
    const temp = {
      preventive_action: [record.id],
      city: this.props.user.cityId,
    };
    notificationAction
      .cityWisePreventiveActionNotification(temp)
      .then((res) => {
        res &&
          res.json().then((criminalList) => {
            console.log("preventive notification", criminalList);
            this.setState({ finalList: criminalList.data, loading: false });
          });
      });
  };

  handleDistrictColumnClick = (record) => {
    const { user } = this.props;
    const districtId = record.districtId;

    this.setState({
      showList: true,
      loading: true,
      countModalTab: "list",
      countModalGraphType: "preventive",
      countModalTitle: record.district || "आरोपी",
    });

    if (!districtId) {
      this.setState({ finalList: [], loading: false });
      return;
    }

    const fetchDetails =
      user?.role === "4"
        ? notificationAction.cityWisePreventiveActionNotification({
            city: user.cityId,
            district: [districtId],
          })
        : notificationAction.distinctPreventiveActionNotification({
            district: [districtId],
          });

    fetchDetails.then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("district wise preventive notification", criminalList);
          this.setState({ finalList: criminalList.data, loading: false });
        });
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      showList: false,
      countModalTitle: "",
      countModalTab: "list",
    });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props.professionals || {};
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  downloadCountModalExcel = () => {
    const { finalList, countModalTitle } = this.state;
    const { t } = this.context;
    const ReportTitle = "Preventive_Notification_Report";
    const title = "प्रतिबंधक_कारवाई";
    const arrData = Array.isArray(finalList) ? finalList : [];
    const safeTitle = (countModalTitle || "Report").replace(/\s+/g, "_");
    const file_name = `${title}_${safeTitle}_${moment().format("DDMMMYYYY")}`;

    const formatDate = (val) =>
      val && moment(val).isValid()
        ? moment(val).format("DD/MM/YYYY")
        : "";

    const formatAlertDate = (val) =>
      val && moment(val).isValid()
        ? moment(val).format("DD-MM-YYYY")
        : "";

    const getMaxLineLength = (value) =>
      String(value ?? "")
        .split("\n")
        .reduce((max, line) => Math.max(max, line.length), 0);

    const getLineCount = (value) =>
      Math.max(
        1,
        String(value ?? "")
          .split("\n")
          .length,
      );

    const formatCrimeRegistration = (item) => {
      const regNo =
        item.registernumber != null && item.registernumber !== ""
          ? String(item.registernumber)
          : "";
      const date = formatDate(item.gunha_dateTime);
      const district = item.guna_districtName || "";

      return `${regNo}\n${date}\n${district}`;
    };

    const formatPreventiveAction = (item) =>
      `${item.preventive_action_name || ""}\n${item.action_taken_police_station || ""}`;

    const formatKkInfo = (item) => {
      const kkInfoArray = Array.isArray(item.kk_info) ? item.kk_info : [];
      if (kkInfoArray.length === 0) return "";

      const grouped = kkInfoArray.reduce((acc, kk) => {
        const name = kk?.rulesName || "-";
        const kalma = kk?.kalam || "-";

        if (!acc[name]) {
          acc[name] = [kalma];
        } else if (!acc[name].includes(kalma)) {
          acc[name].push(kalma);
        }
        return acc;
      }, {});

      return Object.entries(grouped)
        .map(([ruleName, kalams]) =>
          `${ruleName}${kalams.length ? " , " + kalams.join(", ") : ""}`,
        )
        .join("\n");
    };

    const exportData = arrData.map((item, index) => ({
      [t("sr.no")]: index + 1,
      [t("action_taken_police_station")]: item.action_taken_police_station || "",
      [t("preventive_action")]: formatPreventiveAction(item),
      [t("date_from")]: formatDate(item.date_from),
      [t("date_to")]: formatDate(item.date_to),
      [t("name_of_the_accused")]: item.basic_name || "",
      [t("address")]: item.address || "",
      [t("crime_registration_date")]: formatCrimeRegistration(item),
      "कायदा कलम": formatKkInfo(item),
      "अलर्ट दिनांक": formatAlertDate(item.date),
    }));

    if (!exportData.length) {
      message.error("No data available to export.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(exportData, { origin: "A4" });

    const columnKeys = Object.keys(exportData[0]);
    const columnWidths = columnKeys.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...exportData.map((row) => getMaxLineLength(row[key])),
        ) + 6,
    }));
    ws["!cols"] = columnWidths;

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    columnKeys.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index });
      if (!ws[cellRef]) ws[cellRef] = {};
      ws[cellRef].s = headerStyle;
    });

    exportData.forEach((row, rowIndex) => {
      const rowNum = rowIndex + 4;
      let maxLines = 1;

      columnKeys.forEach((key, colIndex) => {
        const value = row[key];
        const lineCount = getLineCount(value);
        maxLines = Math.max(maxLines, lineCount);

        const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: colIndex });
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].s = {
          font: { sz: 12 },
          alignment: {
            horizontal: "center",
            vertical: lineCount > 1 ? "top" : "center",
            wrapText: true,
          },
        };
      });

      if (!ws["!rows"]) ws["!rows"] = [];
      ws["!rows"][rowNum] = { hpt: Math.max(25, maxLines * 20 + 8) };
    });

    ws["A1"] = {
      v: this.getCityName(this.props.user?.cityId || ""),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };

    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;
    const footerRowIndex = exportData.length + 6;
    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];
    ws["!merges"] = mergeRanges;

    ws["!rows"] = ws["!rows"] || Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][0] = { hpt: 25 };
    ws["!rows"][1] = { hpt: 25 };
    ws["!rows"][2] = { hpt: 25 };
    ws["!rows"][3] = { hpt: 30 };
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  handleRead = (data) => {
    console.log("handleRead called with data:", data);
    this.setState({
      read_by: true,
      read_data: data,
    });
  };
  handleClose = (data) => {
    console.log("handleClose called. Current reason:", this.state.reason, "Current read_data:", this.state.read_data, "Current read_by:", this.state.read_by);
    this.setState({
      read_by: false,

      reason: "",
    });
    if (
      this.state.reason !== "रद्द करून नव्याने कारवाई केली आहे." &&
      this.state.reason !== "रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे."
    ) {
      this.setState({
        read_data: [],
      });
    }
    console.log("State after handleClose:", this.state.read_by, this.state.reason, this.state.read_data);
  };

  handleSubmit = () => {
    console.log("handleSubmit called. Current state: reason=", this.state.reason, "date=", this.state.date, "read_data=", this.state.read_data);
    const { read_data, reason } = this.state;
    console.log("read data", read_data);
    console.log("Selected Reason:", this.state.reason);
    const temp = {
      id: read_data.id,
      read_by: true,
      reason: reason,
    };
    notificationAction.updateInformation(temp).then((res) => {
      if (
        this.state.reason != "रद्द करून नव्याने कारवाई केली आहे." ||
        this.state.reason != "रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे."
      ) {
        message.success("Updated successfully");
      }
    });
    if (this.state.date) {
      let data = {
        preventiveInformationData: {
          date_of_cancellation_of_action: moment(this.state.date).format(
            "YYYY-MM-DD"
          ),
        },
        currentuser: { ...this.props.user },
      };

      this.props.dispatch(
        professionalAction.updatePreventive(read_data?.preventive_id, data)
      );
      message.success("संबंधित कारवाई रद्द करण्यात आलेली आहे");
      if (
        this.state.reason === "रद्द करून नव्याने कारवाई केली आहे." ||
        this.state.reason === "रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे."
      ) {
        console.log("Calling openAddPrevetivePopUp from handleSubmit");
        this.openAddPrevetivePopUp();
        // this.onPreventiveViewAccusedForm(read_data?.basic_id)
        // this.handleClose();
      }
    } else {
      this.handleClose();
    }
    this.props.preventiveNotification();
  };

  showpreventiveDrawer = () => {
    this.setState({
      preventiveDrawer: true,
      isPreventiveEdit: false,
      resetPreventiveForm: true,
    });
  };

  onpreventiveDrawerClose = () => {
    this.setState({
      preventiveDrawer: false,
    });
  };

  preventiveInformationFinish = (data) => {
    console.log("data preventive data save", data);
    this.setState((prevState) => ({
      preventiveInformationData: [data],
      newpreventiveInformationData: [data],
    }));
  };

  preventiveInformationUpdate = (data) => {
    this.setState((prevState) => ({
      preventiveInformationData: [data],
      newpreventiveInformationData: [data],
    }));
    console.log("data preventive data update", data);
  };

  onPreventiveInfomationSave = async () => {
    const values = await this.preventiveInfoRef.current.onFinish();

    if (!values) {
      message.error("Please fix the validation errors before saving.");
      return; // stop execution if invalid
    }

    this.preventiveInfoRef.current.onFinish(true);
    console.log(
      "preventiveInformationData save",
      this.state.preventiveInformationData
    );
    console.log(
      "newpreventiveInformationData",
      this.state.newpreventiveInformationData
    );
    console.log("values", values);
    setTimeout(() => {
      let data = {
        preventiveInformationData: {
          ...values,
          date_from: values.date_from
            ? moment(values.date_from).format("YYYY-MM-DD")
            : null,
          date_to: values.date_to
            ? moment(values.date_to).format("YYYY-MM-DD")
            : null,
          date_issue_bond: values.date_issue_bond
            ? moment(values.date_issue_bond).format("YYYY-MM-DD")
            : null,
          proposal_sent_date: values.proposal_sent_date
            ? moment(values.proposal_sent_date).format("YYYY-MM-DD")
            : null,
          chaptorCaseYear: values.chaptorCaseYear
            ? moment(values.chaptorCaseYear).format("YYYY")
            : null,
          tadipar_unit: values.tadipar_unit
            ? values.tadipar_unit.toString()
            : null,
          orderFIle: values.orderFIle ? values.orderFIle : null,
          orderType: values.orderType ? values.orderType : null,
          masterId: this.state.read_data?.basic_id,

          userId: this.props.user && this.props.user.id,
        },
        currentuser: { ...this.props.user },
      };
      this.props.dispatch(professionalAction.createPreventiveAction(data));
      message.info("Save Successfully !!");
      this.onpreventiveDrawerClose();
      this.onClosePreventiveAccusedDrawer();
      this.preventiveInfoRef.current.resetForm();
      // rest unchanged...
    }, 500);
  };

  onPreventiveInfomationUpdate = async () => {
    const values = await this.preventiveInfoRef.current.onFinish();
    console.log("values edit", values);

    if (!values) {
      message.error("Please fix the validation errors before saving.");
      return; // stop execution if invalid
    }

    this.preventiveInfoRef.current.onFinish(true);

    console.log(
      "preventiveInformationData save",
      this.state.preventiveInformationData[0]
    );
    setTimeout(() => {
      let data = {
        preventiveInformationData: {
          date_from: values.date_from
            ? moment(values.date_from).format("YYYY-MM-DD")
            : null,
          date_to: values.date_to
            ? moment(values.date_to).format("YYYY-MM-DD")
            : null,
          date_issue_bond: values.date_issue_bond
            ? moment(values.date_issue_bond).format("YYYY-MM-DD")
            : null,
          proposal_sent_date: values.proposal_sent_date
            ? moment(values.proposal_sent_date).format("YYYY-MM-DD")
            : null,
          chaptorCaseYear: values.chaptorCaseYear
            ? moment(values.chaptorCaseYear).format("YYYY")
            : null,
          tadipar_unit: values.tadipar_unit
            ? values.tadipar_unit.toString()
            : null,
          orderFIle: values.orderFIle ? values.orderFIle : null,
          orderType: values.orderType ? values.orderType : null,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          action_taken_police_station: values.action_taken_police_station,
        },
        currentuser: { ...this.props.user },
      };

      this.props.dispatch(
        professionalAction.updatePreventive(
          this.state.editPreventiveInformationData[0].id,
          data
        )
      );
      message.info("Update Successfully !!");
      this.onpreventiveDrawerClose();
      this.onClosePreventiveAccusedDrawer();
      this.setState({ preventiveInformationData: [] });
      // rest unchanged...
    }, 500);
  };

  onPreventiveViewAccusedForm = (data) => {
    this.setState({ preventiveInformationData: [], addPrevetivePopUp: false,read_by:false });
    professionalAction.getPreventiveToolByID(data).then((res) => {
      res &&
        res.text().then((criminalList) => {
          this.setState({
            preventiveInformationData: criminalList && JSON.parse(criminalList),
          });
        });
    });

    this.setState({
      userID: data.userId,
    });

    this.setState({
      isAccusedFormEdit: [
        {
          editId: data,
          isEdit: true,
        },
      ],
      isEditForms: true,
      accusedPreventiveDrawer: true,
      newPreventive: false,
      resetBasicForm: false,
      newflag: 1,
    });
  };

  onClosePreventiveAccusedDrawer = () => {
    this.setState((prevState) => ({
      accusedPreventiveDrawer: false,
      read_data: [],
    }));
  };

  render() {
    console.log("this.props.data", this.props);
    const { language, t } = this.context;
    let tempColumns = [];
    const { user } = this.props;
    console.log("this.state.preventiveAction", this.state.preventiveAction);
    console.log("this.state",this.state)
    let columnsOb =
      this.props.list === "list"
        ? [
            {
              title: t("sr.no"),
              key: t("sr.no"),
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.srNo}
                </Space>
              ),
            },
            {
              title: t("action_taken_police_station"),
              key: "action_taken_police_station",
              dataIndex: "action_taken_police_station",
              onHeaderCell: () => ({
                style: {
                  backgroundColor: "#ffcc80",
                  color: "#000",
                  fontWeight: "bold",
                },
              }),
              onCell: () => ({
                style: {
                  backgroundColor: "#ffcc80",
                  color: "#000",
                },
              }),
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.action_taken_police_station}
                </Space>
              ),
            },
            {
              title: t("preventive_action"),
              key: "preventive_action_name",
              dataIndex: "preventive_action_name",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.preventive_action_name}
                </Space>
              ),
            },
            {
              title: t("date_from"),
              key: "date_from",
              dataIndex: "date_from",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {moment(record?.date_from).format("DD/MM/YYYY")}
                </Space>
              ),
            },
            {
              title: t("date_to"),
              key: "date_to",
              dataIndex: "date_to",
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {moment(record?.date_to).format("DD/MM/YYYY")}
                </Space>
              ),
            },
            {
              title: t("name_of_the_accused"),
              key: "name",
              dataIndex: "name",
              render: (text, record) => (
                <Space
                  size="middle"
                  style={{ maxWidth: 300 }}
                  title={record.masterid}
                >
                  {record?.basic_name}
                </Space>
              ),
            },
            {
              title: t("address"),
              key: "name",
              dataIndex: "name",
              render: (text, record) => (
                <Space
                  size="middle"
                  style={{ maxWidth: 300 }}
                  title={record.masterid}
                >
                  {record?.address}
                </Space>
              ),
            },
          
            {
              title: t("crime_register_number") ,
              key: "registernumber",
              dataIndex: "registernumber",
              sorter: {
                compare: (a, b) =>
                  a.registernumber - b.registernumber,
              },
              render: (text, record) => (
                <>
                  <p>{record?.registernumber}</p>
                   <p>{moment(record?.gunha_dateTime).format("DD/MM/YYYY")}</p>
                  <p>{record?.districtName}</p>
                </>
              ),
            },
            // {
            //   title: t("crime_registration_date"),
            //   key: "crime_registration_date",
            //   dataIndex: "gunha_dateTime",
            //   sorter: {
            //     compare: (a, b) =>
            //       a.gunha_dateTime - b.gunha_dateTime,
            //   },
            //   sorter: (a, b) => {
            //     const dateA = new Date(a.gunha_dateTime);
            //     const dateB = new Date(b.gunha_dateTime);

            //     if (dateA.getTime() === dateB.getTime()) {
            //       // If dates are same → sort by district name (alphabetical)
            //       return (a.guna_districtName || "").localeCompare(
            //         b.guna_districtName || ""
            //       );
            //     }
            //     return dateA - dateB;
            //   },
            //   render: (text, record) => (
            //     <>
            //       <p>{moment(record?.gunha_dateTime).format("DD/MM/YYYY")}</p>
            //       <p>{record?.guna_districtName}</p>
            //     </>
            //   ),
            // },

            {
              title: "कायदा कलम",
              key: "name",
              dataIndex: "name",
              render: (text, record) => {
                const kkInfoArray = Array.isArray(record.kk_info)
                  ? record.kk_info
                  : [];

                if (kkInfoArray.length === 0) return null;

                // Group kalam → unique rules
                const grouped = kkInfoArray.reduce((acc, item) => {
                  const name = item?.rulesName || "-"; // rule name
                  const kalma = item?.kalam || "-"; // kalam

                  if (!acc[name]) {
                    acc[name] = [kalma];
                  } else if (!acc[name].includes(kalma)) {
                    acc[name].push(kalma);
                  }
                  return acc;
                }, {});

                return (
                  <Space
                    direction="vertical"
                    size="small"
                    style={{ maxWidth: 300 }}
                  >
                    {Object.entries(grouped).map(([ruleName, kalams], idx) => (
                      <p key={idx}>
                        {`${ruleName}${
                          kalams.length ? " , " + kalams.join(", ") : ""
                        }`}
                      </p>
                    ))}
                  </Space>
                );
              },
            },
            {
              title: "अलर्ट दिनांक",
              key: "date",
              render: (text, record) => (
                <Space
                  direction="vertical"
                  size="small"
                  style={{ maxWidth: 300 }}
                >
                  {moment(record.date).format("DD-MM-YYYY")}
                </Space>
              ),
            },
            {
              title: t("action"),
              key: "action",
              render: (text, record) => (
                <div className="action-links-responsive">
                  <Button
                    type="text"
                    size="small"
                    className="action-link update-link"
                    onClick={() => {
                      this.handleRead(record);
                      this.setState({
                        accusedPreventiveDrawer: false,
                        preventiveDrawer: false,
                      });
                    }}
                  >
                    {t("read_by")}
                  </Button>

                  <Button
                    type="text"
                    size="small"
                    className="action-link update-link"
                    onClick={() => {
                      this.handleViewForm(record.masterid);
                    }}
                  >
                    {t("view1")}
                  </Button>
                </div>
              ),
            },
          ]
        : this.props.countbtn == "preventive" && this.props.data && this.props.data.length > 0
        ? [
            {
              title: "Sr No",
              dataIndex: "serialNumber",
              key: "serialNumber",
              render: (text, record, index) => index + 1,
            },
            ...Object.keys(this.props.data[0])
              .filter((key) => key !== "id")
              .map((key) => ({
                title: key, // keep normal header
                dataIndex: key,
                key: key,
                render:
                  key === "count"
                    ? (text, record) => (
                        <Button
                        type="primary"
                        size="small"
                        shape="circle"
                        style={{
                          width: 36,
                          height: 36,
                          fontWeight: 600,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                          cursor: record.count === 0 ? "not-allowed" : "pointer",
                        }}
                          disabled={record.count === 0}
                          onClick={() => this.handleColumnClick(record)}
                      
                        >
                          {text}
                        </Button>
                      )
                    : undefined, // other columns stay normal
              })),
          ]
        : this.props.countbtn == "district" && this.props.data && this.props.data.length > 0
        ? [
            {
              title: "Sr No",
              dataIndex: "serialNumber",
              key: "serialNumber",
              render: (text, record, index) => index + 1,
            },
            {title: t("police_station"),
              dataIndex: "district",
              key: "district",
            },
            {title: t("count"),
              dataIndex: "count",
              key: "count",
              render: (text, record) => (
                <Button
                  type="primary"
                  size="small"
                  shape="circle"
                  style={{
                    width: 36,
                    height: 36,
                    fontWeight: 600,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    cursor: record.count === 0 ? "not-allowed" : "pointer",
                  }}
                  disabled={record.count === 0}
                  onClick={() => this.handleDistrictColumnClick(record)}
                >
                  {text}
                </Button>
              ),
            },
          ]
        : [];
    let tableData =
      this.props.data?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || [];

    // columns.push(
    //   ...columnsOb
    // );

    return (
      <>
        <Spin spinning={this.props.loading} delay={500}>
          <div style={{ marginBottom: 16 }}>
            <span style={{ marginLeft: 8 }}></span>
          </div>

          <Table key={tableData} columns={columnsOb} dataSource={tableData} />
        </Spin>
        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            name={this.state.name}
            onClose={this.closeImageModal}
          />
        )}
        <Modal
          title={this.state.countModalTitle || "आरोपी"}
          top
          visible={this.state.showList}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
          destroyOnClose
          footer={null}
        >
          {this.renderCountModalToggle()}
          {this.state.countModalTab === "list" ? (
            <CountPreventiveNotificationList
              data={this.state.finalList}
              loading={this.state.loading}
            />
          ) : (
            this.renderCountModalGraph()
          )}
        </Modal>
        <Drawer
          title="Select Reason"
          centered
          open={this.state.read_by}
          maskClosable={false}
          closable={false}
          onClose={this.handleClose}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button onClick={this.handleClose} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                </div>
                {/* <div>
                <Button
                  onClick={this.onPreventiveInfomationSave}
                  type="primary" >
                   Save
                </Button>
                </div> */}
              </div>
            </div>
          }
          // width="80vw" // increased width for better responsiveness
          // style={{ overflowY: "auto" }} // Ensures the entire modal scrolls if content overflows
        >
          <Form layout="vertical">
            <Form.Item
              label="Reason"
              style={{ position: "relative", overflow: "visible" }}
            >
              <Select
                style={{ width: "100%" }}
                placeholder="Please select a value"
                value={this.state.reason}
                onChange={(value) => this.setState({ reason: value })}
                open={this.state.isSelectOpen} // Control dropdown visibility with state
                onDropdownVisibleChange={(visible) =>
                  this.setState({ isSelectOpen: visible })
                } // Update state on visibility change
                getPopupContainer={(triggerNode) => triggerNode.parentNode} // dropdown inside modal
                dropdownStyle={{
                  maxHeight: 250, // dropdown scrollable
                  overflowY: "auto",
                  zIndex: 9999, // Ensure dropdown appears on top
                }}
                virtual={false} // Disable virtualization to ensure all options are rendered
                showSearch // Enable searching in dropdown
                optionFilterProp="children" // Filter options by their children (text)
              >
                <Option value="रद्द करून नव्याने कारवाई केली आहे.">
                  रद्द करून नव्याने कारवाई केली आहे.
                </Option>
                <Option value="रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे.">
                  रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे.
                </Option>
                <Option value="गुन्हा दाखल झाला त्याच दिवशी कारवाई करण्यात आली आहे.">
                  गुन्हा दाखल झाला त्याच दिवशी कारवाई करण्यात आली आहे.
                </Option>
                <Option value="तारखा चुकीच्या टाकल्या गेल्या, अपडेट केले आहे.">
                  तारखा चुकीच्या टाकल्या गेल्या, अपडेट केले आहे.
                </Option>
                <Option value="चुकीचे नोटिफिकेशन आले आहे.">
                  चुकीचे नोटिफिकेशन आले आहे.
                </Option>
                <Option value="मकोका अंतर्गत 142 अन्वये कारवाई केली आहे.">
                  मकोका अंतर्गत 142 अन्वये कारवाई केली आहे.
                </Option>
                <Option value="आरोपी सध्या जेल मध्ये आहे.">
                  आरोपी सध्या जेल मध्ये आहे.
                </Option>
                <Option value="नजरचुकीने भरले गेले.">
                  नजरचुकीने भरले गेले.
                </Option>
                <Option value="इतर">इतर</Option>
              </Select>
            </Form.Item>
            {(this.state.reason === "रद्द करून नव्याने कारवाई केली आहे." ||
              this.state.reason ===
                "रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे.") && (
              <>
                <Form.Item label={t("date_of_cancellation_of_action")}>
                  <DatePicker
                    placeholder="Select Date"
                    onChange={(e) => {
                      this.setState({
                        date: e,
                      });
                    }}
                    defaultPickerValue={moment(this.state.read_data.date_from)}
                    disabledDate={(current) => {
                      const { read_data } = this.state;
                      const dateFrom = moment(read_data.date_from);
                      const dateTo = moment(read_data.date_to);
                      return (
                        (current && current < dateFrom)
                        //  ||
                        // (current && current > dateTo)
                      );
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  />
                </Form.Item>
              </>
            )}

            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Button
                type="primary"
                onClick={this.handleSubmit}
                disabled={
                  !this.state.reason ||
                  ((this.state.reason ===
                    "रद्द करून नव्याने कारवाई केली आहे." ||
                    this.state.reason ===
                      "रद्द करून नवीन कारवाई साठी प्रस्ताव पाठवला आहे.") &&
                    !this.state.date)
                }
                // disabled until an option is selected
              >
                Submit
              </Button>
            </div>
          </Form>
        </Drawer>
        <Drawer
          title="प्रोफेशनल क्रिमिनल Preventive (प्रतिबंधक कारवाही)"
          width={800}
          maskClosable={false}
          closable={false}
          onClose={this.onClosePreventiveAccusedDrawer}
          visible={this.state.accusedPreventiveDrawer}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onClosePreventiveAccusedDrawer}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </div>
                {/* <div>
                <Button
                  onClick={this.onPreventiveInfomationSave}
                  type="primary" >
                   Save
                </Button>
                </div> */}
              </div>
            </div>
          }
        >
          <div className="steps-content mb-4" style={{ marginTop: "2px" }}>
            <Button
              type="primary"
              style={{ marginBottom: "5px" }}
              onClick={this.showpreventiveDrawer}
            >
              प्रतिबंधक कारवाही जोडा
            </Button>
            {this.state.preventiveInformationData.length ? (
              <PreventiveInfomationTable
                data={this.state.preventiveInformationData}
                editPreventiveInfomation={this.editPreventiveInfomation}
                //deleteGhunhaInfomation={this.deleteGhunhaInfomation}
                professionals={this.props.professionals}
                isEditForms={this.state.isEditForms}
                preventiveAction={this.state.preventiveAction}
                role={this.props.user.role}
                user={this.props.user}
              ></PreventiveInfomationTable>
            ) : null}

            <Drawer
              title="प्रतिबंधक कारवाही"
              width={800}
              maskClosable={false}
              closable={false}
              onClose={this.onpreventiveDrawerClose}
              visible={this.state.preventiveDrawer}
              footer={
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <Button
                    onClick={this.onpreventiveDrawerClose}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                  {!this.state.isPreventiveEdit ? (
                    <Button
                      onClick={this.onPreventiveInfomationSave}
                      type="primary"
                      htmlType="submit"
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      onClick={this.onPreventiveInfomationUpdate}
                      type="primary"
                      htmlType="submit"
                    >
                      Update
                    </Button>
                  )}
                </div>
              }
            >
              <PreventiveForm
                ref={this.preventiveInfoRef}
                preventiveInformationFinish={this.preventiveInformationFinish}
                preventiveInformationUpdate={this.preventiveInformationUpdate}
                preventiveInformationData={this.state.preventiveInformationData}
                editPreventiveInformationData={
                  this.state.editPreventiveInformationData
                }
                dataStates={this.props.professionals}
                isEditForms={this.state.isEditForms}
                resetPreventiveForm={this.state.resetPreventiveForm}
                preventiveAction={this.state.preventiveAction}
                role={user?.role}
                district={user?.districtId}
              ></PreventiveForm>
            </Drawer>
          </div>
        </Drawer>
        <Modal
          title="प्रतिबंधक कारवाही"
          visible={this.state.addPrevetivePopUp}
          onCancel={this.closeAddPrevetivePopUp}
          centered
        >
          <p style={{ textAlign: "center" }}>
            {t("confirm_new_preventive_action")}
          </p>
          <div style={{ textAlign: "center" }}>
            <Button key="no" onClick={this.closeAddPrevetivePopUp}>
              {t("no")}
            </Button>
            <Button
              key="yes"
              type="primary"
              style={{ marginLeft: "10px" }}
              onClick={() =>
                this.onPreventiveViewAccusedForm(this.state.read_data?.basic_id)
              }
            >
              {t("yes")}
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedTableWanted = connect(mapStateToProps)(
  TablePreventiveNotificationMemo
);
export { connectedTableWanted as TablePreventiveNotification };
